import * as IoC from 'inversify';
import { registerCommand } from '@/app/tracking/api';
import { registerQuery } from '@/app/tracking/common';
import { UpdateQuizSessionTrackingCommandName, QueryQuizSessionsTrackingQueryName,
         DeleteQuizSessionTrackingCommandName } from '../api'
import { quizSessionCommonTrackingModule } from '../common/di'
import { Scorm2004UpdateQuizSessionCommandHandler } from './scorm2004-update-quiz-session-command-handler'
import { Scorm2004DeleteQuizSessionCommandHandler } from './scorm2004-delete-quiz-session-command-handler'
import { Scorm2004QueryQuizSessionsQueryHandler } from './scorm2004-query-quiz-sessions-query-handler';

const quizSessionScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(UpdateQuizSessionTrackingCommandName, Scorm2004UpdateQuizSessionCommandHandler, bind);
  registerCommand(DeleteQuizSessionTrackingCommandName, Scorm2004DeleteQuizSessionCommandHandler, bind);
  registerQuery(QueryQuizSessionsTrackingQueryName, Scorm2004QueryQuizSessionsQueryHandler, bind);
})

export const quizSessionScorm2004TrackingModules = [
  quizSessionCommonTrackingModule,
  quizSessionScorm2004TrackingModule
]
